export type FontWeight = 'Regular' | 'Medium' | 'Semi Bold'
export type FontSize = '48' | '40' | '32' | '28' | '24' | '18' | '16' | '14' | '12' | '10'
export type LineHeight = '58' | '48' | '38' | '34' | '28' | '24' | '20' | '16' | '14' | '12'

export const fontWeightValues = {
  'Regular': 400,
  'Medium': 500,
  'Semi Bold': 600,
  'Bold': 700,
}

export const typography = {
  h1: {
    "font-size": '48px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '58px',
  },
  h2: {
    "font-size": '40px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '48px',
  },
  h3: {
    "font-size": '32px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '38px',
  },
  h4: {
    "font-size": '28px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '34px',
  },
  h5: {
    "font-size": '24px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '28px',
  },
  subtitle1: {
    "font-size": '18px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '28px',
  },
  subtitle2: {
    "font-size": '16px',
    "font-weight": fontWeightValues['Semi Bold'],
    "line-height": '24px',
  },
  body1: {
    "font-size": '16px',
    "font-weight": fontWeightValues['Regular'],
    "line-height": '24px',
  },
  body2: {
    "font-size": '16px',
    "font-weight": fontWeightValues['Medium'],
    "line-height": '24px',
  },
  body3: {
    "font-size": '14px',
    "font-weight": fontWeightValues['Regular'],
    "line-height": '20px',
  },
  body4: {
    "font-size": '14px',
    "font-weight": fontWeightValues['Medium'],
    "line-height": '20px',
  },
  caption1: {
    "font-size": '12px',
    "font-weight": fontWeightValues['Regular'],
    "line-height": '16px',
  },
  caption2: {
    "font-size": '12px',
    "font-weight": fontWeightValues['Medium'],
    "line-height": '16px',
  },
  caption3: {
    "font-size": '10px',
    "font-weight": fontWeightValues['Medium'],
    "line-height": '14px',
  },
  label: {
    "font-size": '12px',
    "font-weight": fontWeightValues['Medium'],
    "line-height": '16px',
  },
  button: {
    giant: {
      "font-size": '18px',
      "font-weight": fontWeightValues['Semi Bold'],
      "line-height": '24px',
    },
    large: {
      "font-size": '16px',
      "font-weight": fontWeightValues['Semi Bold'],
      "line-height": '20px',
    },
    medium: {
      "font-size": '14px',
      "font-weight": fontWeightValues['Semi Bold'],
      "line-height": '16px',
    },
    small: {
      "font-size": '12px',
      "font-weight": fontWeightValues['Semi Bold'],
      "line-height": '16px',
    },
    tiny: {
      "font-size": '10px',
      "font-weight": fontWeightValues['Semi Bold'],
      "line-height": '12px',
    },
  },
} as const 